// extracted by mini-css-extract-plugin
module.exports = {"container":"_a3","title":"_a4","text":"_a5"};